module.exports = __webpack_public_path__ + "img/r-michelle-tsang-500721-unsplash-min-800x527.42f86c30.jpg";